import { render, staticRenderFns } from "./formDesign.vue?vue&type=template&id=52fa4628"
import script from "./formDesign.vue?vue&type=script&lang=js"
export * from "./formDesign.vue?vue&type=script&lang=js"
import style0 from "./formDesign.vue?vue&type=style&index=0&id=52fa4628&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports